export enum UserVoiceSearchTeam {
    MailSearch,
    CalendarSearch,
}
